const appleStoreUrl = 'https://apps.apple.com/us/app/iautho/id1495116381';
const googlePlayStoreUrl = 'https://play.google.com/store/apps/details?id=com.iautho';

module.exports = {
  appleStoreUrl,
  googlePlayStoreUrl,
};
